import { styled } from "styled-components";

import { BackgroundField, generateFieldsStyles } from "../../styles";

export const SectionGroup = styled.div<{ background: BackgroundField[] }>(
    ({ background }) => background && generateFieldsStyles(background)
);
